export default __webpack_public_path__ + "static/media/img-0045.03db7bb4.png";